import gql from 'graphql-tag';

export const findLinkRaiz = gql`
query findLinkRaiz {
    findLinkRaiz {
        uuid
        nombre
        nodeLinkChilds 
        labels
    }
}`

export const findNodeLinkElementDescendancy = gql`
query findNodeLinkElementDescendancy ($uuid: String) {
    findNodeLinkElementDescendancy(uuid: $uuid) {
        uuid
        nombre
        nodeLinkChilds 
        labels
    }
}`

//Get properties by label
export const findMbDevice = gql`
query findMbDevice($uuid: String) {
    findMbDevice(uuid: $uuid) {
        uuid
        address
        labels
    }
}`

export const findMbRtu = gql`
query findMbRtu($uuid: String) {
    findMbRtu(uuid: $uuid) {
        uuid
        path
        labels
    }
}`

export const findMbTelnet = gql`
query findMbTelnet($uuid: String) {
    findMbTelnet(uuid: $uuid) {
        uuid
        ip
        port
        labels
    }
}`

export const findHost = gql`
query findHost($uuid: String) {
    findHost(uuid: $uuid) {
        uuid
        ip
        labels
    }
}`

export const findNodeLink = gql`
query findNodeLink($uuid: String) {
    findNodeLink(uuid: $uuid) {
        uuid
        nombre
        nodeLinks
        nodeLinkChilds
    }
}`

export const findSource = gql`
query findSource($uuid: String) {
    findSource(uuid: $uuid) {
        uuid
        nombre
        topic
        modelo
    }
}`

export const findMbBus = gql`
query findMbBus($uuid: String){
    findMbBus(uuid: $uuid) {
        uuid
        baudRate
        parity
        dataBits
        stopBits
        timeout
        wait
        labels
    }
}`

export const findMbTcp = gql`
query findMbTcp($uuid: String){
    findMbTcp(uuid: $uuid) {
        uuid
        host
        port
        labels
    }
}`

export const findSwitch = gql`
query findSwitch($uuid: String){
    findSwitch(uuid: $uuid) {
        uuid
        nombre
        labels
    }
}`

//Update and create nodeLink
export const createRootNodeLink = gql`
mutation($nombre: String, $labels: [String]) {
    createRootNodeLink(nombre: $nombre, labels: $labels) {
        uuid
        nombre
        labels
    }
}`

export const createChildNodeLink = gql`
mutation createChildNodeLink($uuid: String, $nombre: String, $labels: [String]){
    createChildNodeLink(uuid: $uuid, nombre: $nombre, labels: $labels) {
        uuid
        nombre
        labels
    }
}`

export const updateNodeLinkElement = gql`
mutation updateNodeLinkElement 
    ($uuid: String, $nombre: String, $labels: [String]) {
        updateNodeLink(uuid: $uuid, nombre: $nombre, labels: $labels) {
            uuid
            nombre
            labels
        }
}`

export const updateMbBus = gql`
mutation updateMbBus
    ($uuid: String, $baudRate: Int, $dataBits: Int, $parity: String, $stopBits: Int, $timeout: Int, $wait: Int) {
    updateMbBus (uuid: $uuid, baudRate: $baudRate, parity: $parity, dataBits: $dataBits, stopBits: $stopBits, timeout: $timeout, wait: $wait) {
        uuid 
        baudRate
        parity
        dataBits
        stopBits
        timeout
        wait
        labels
    }
}`

export const updateMbDevice = gql`
mutation updateMbDevice($uuid: String, $address: Int) {
    updateMbDevice(uuid: $uuid,address: $address) {
        uuid
        address
    }
}`

export const updateSource = gql`
mutation updateSource($uuid: String, $nombre: String){
    updateSource (uuid: $uuid, nombre: $nombre) {
        uuid
        nombre
        topic
        modelo
    }
}`

export const updateLmPing = gql`
mutation updateLmPing($uuid: String, $host: String){
    updateLmPing (uuid: $uuid, host: $host) {
        uuid
        host
    }
}`

export const updateHost = gql`
mutation updateHost($uuid: String, $ip: String){
    updateHost(uuid: $uuid, ip: $ip) {
        uuid
        ip
        labels
    }
}`

export const updateMbRtu = gql`
mutation updateMbRtu($uuid: String, $path: String){
    updateMbRtu (uuid: $uuid, path: $path) {
        uuid
        path
        labels
    }
}`

export const updateMbTelnet = gql`
mutation updateMbTelnet($uuid: String, $ip: String, $port: Int) {
    updateMbTelnet(uuid: $uuid,ip: $ip,port: $port) {
        uuid
        ip
        port
        labels
    }
}`

export const updateMbTCP = gql`
mutation updateMbTCP($uuid: String, $port: Int, $host: String){
    updateMbTcp(uuid: $uuid, port: $port, host: $host) {
        uuid
        host
        labels
    }
}`

export const updateMbSerie = gql`
mutation updateMbSerie($uuid: String){
    updateMbSerie (uuid: $uuid) {
        uuid
    }
}`

export const updateSwitch = gql`
mutation updateSwitch($uuid: String, $nombre: String){
    updateSwitch (uuid: $uuid, nombre: $nombre){
        uuid
        nombre
        labels
    }
}`

export const updateFieldMb = gql`
mutation updateFieldMb($uuid: String, $gateway: String, $topic: String, $host: 
String){
    updateFieldMb(uuid: $uuid, gateway: $gateway, topic: $topic, host: $host ) {
        uuid
        gateway
        topic
        host
    }
}`

// export const updateMbRtuDevice = gql`
// mutation($uuid: ID!, $nombre: String!, $path: String, $baudRate: Int, $parity:String,
//   $dataBits: Int, $stopBits: Int
//   ) {
//     UpdateMbBus(uuid: $uuid, nombre: $nombre, path: $path, baudRate: $baudRate, parity: $parity
//       dataBits: $dataBits, stopBits: $stopBits) {
//         uuid
//         nombre
//         path
//         baudRate
//         parity
//         dataBits
//         stopBits
//   }
// }`;
